/**
 * @generated SignedSource<<24fc749c9cf42dfadf71942520757484>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type DashboardBlockContentMode = "full" | "preview" | "%future added value";
export type DashboardBlockCurriculumView = "card" | "list" | "%future added value";
export type DashboardBlockEventsView = "card" | "list" | "%future added value";
export type DashboardBlockFeaturedItemConfigKind = "collection" | "event" | "experience" | "membership" | "%future added value";
export type DashboardBlockFeedView = "card" | "list" | "%future added value";
export type DashboardBlockHeroMode = "color" | "image" | "no_fill" | "%future added value";
export type DashboardBlockLeaderboardLookbackWindow = "last_30_days" | "last_365_days" | "last_7_days" | "last_90_days" | "last_month" | "last_week" | "last_year" | "this_month" | "this_week" | "this_year" | "%future added value";
export type DashboardBlockLeaderboardView = "card" | "list" | "%future added value";
export type DashboardBlockMembersListMemberType = "admin_only" | "all" | "member_only" | "%future added value";
export type EditDashboardBlockInput = {
  banner?: BannerDashboardBlockInput | null;
  channels?: ChannelsDashboardBlockInput | null;
  collectionFolder?: CollectionFolderDashboardBlockInput | null;
  communityWelcomeHero?: CommunityWelcomeHeroDashboardBlockInput | null;
  content?: ContentDashboardBlockInput | null;
  continueYourProducts?: ContinueYourProductsDashboardBlockInput | null;
  curriculum?: CurriculumDashboardBlockInput | null;
  dashboardBlockId: string;
  experienceDetails?: ExperienceDetailsDashboardBlockInput | null;
  featuredItems?: FeaturedItemsDashboardBlockInput | null;
  feed?: FeedDashboardBlockInput | null;
  hero?: HeroDashboardBlockInput | null;
  leaderboard?: LeaderboardDashboardBlockInput | null;
  membersList?: MembersListDashboardBlockInput | null;
  richText?: RichTextDashboardBlockInput | null;
  showOnMobile: boolean;
  upcomingEvents?: UpcomingEventsDashboardBlockInput | null;
  welcomeBanner?: WelcomeBannerDashboardBlockInput | null;
};
export type LeaderboardDashboardBlockInput = {
  count?: number | null;
  description?: string | null;
  lookbackWindow?: DashboardBlockLeaderboardLookbackWindow | null;
  title?: string | null;
  view?: DashboardBlockLeaderboardView | null;
};
export type WelcomeBannerDashboardBlockInput = {
  cover?: string | null;
  coverAssetId?: string | null;
  hideAfter?: string | null;
  richEditorDescription?: string | null;
  subtitle?: string | null;
  title?: string | null;
};
export type FeaturedItemsDashboardBlockInput = {
  featuredKind: DashboardBlockFeaturedItemConfigKind;
  featuredProductIds?: ReadonlyArray<string> | null;
  showCountdown?: boolean | null;
};
export type RichTextDashboardBlockInput = {
  ctaText?: string | null;
  ctaUrl?: string | null;
  hasCtaButton?: boolean | null;
  richEditorContent?: string | null;
  title?: string | null;
};
export type ContentDashboardBlockInput = {
  contentIds?: ReadonlyArray<string> | null;
  mode: DashboardBlockContentMode;
};
export type CollectionFolderDashboardBlockInput = {
  contentId: string;
};
export type ExperienceDetailsDashboardBlockInput = {
  description?: string | null;
  showAttendance?: boolean | null;
  showCountdown?: boolean | null;
  showDates?: boolean | null;
  showMembers?: boolean | null;
  showProgress?: boolean | null;
};
export type UpcomingEventsDashboardBlockInput = {
  count?: number | null;
  eventType?: string | null;
  showCover?: boolean | null;
  view?: DashboardBlockEventsView | null;
};
export type MembersListDashboardBlockInput = {
  count?: number | null;
  memberType?: DashboardBlockMembersListMemberType | null;
};
export type FeedDashboardBlockInput = {
  showCover?: boolean | null;
  title: string;
  view: DashboardBlockFeedView;
};
export type CurriculumDashboardBlockInput = {
  title: string;
  view?: DashboardBlockCurriculumView | null;
};
export type ContinueYourProductsDashboardBlockInput = {
  title: string;
};
export type ChannelsDashboardBlockInput = {
  title: string;
};
export type BannerDashboardBlockInput = {
  cover?: string | null;
  coverAssetId?: string | null;
  showAvailability?: boolean | null;
  showCountdown?: boolean | null;
  showCover?: boolean | null;
  showDates?: boolean | null;
  showProgress?: boolean | null;
};
export type CommunityWelcomeHeroDashboardBlockInput = {
  cover?: string | null;
  coverAssetId?: string | null;
  subtitle?: string | null;
  title?: string | null;
};
export type HeroDashboardBlockInput = {
  askAi: boolean;
  color?: string | null;
  cover?: string | null;
  coverAssetId?: string | null;
  header?: string | null;
  mode: DashboardBlockHeroMode;
  showWelcomeText: boolean;
  subText?: string | null;
  textColor?: string | null;
};
export type EditDashboardBlockFormMutation$variables = {
  input: EditDashboardBlockInput;
};
export type EditDashboardBlockFormMutation$data = {
  readonly response: {
    readonly errors: ReadonlyArray<{
      readonly field: string;
      readonly message: string;
    }> | null;
    readonly node: {
      readonly " $fragmentSpreads": FragmentRefs<"DashboardBlockItemFragment" | "EditDashboardBlockFormFragment">;
    } | null;
  };
};
export type EditDashboardBlockFormMutation = {
  response: EditDashboardBlockFormMutation$data;
  variables: EditDashboardBlockFormMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "concreteType": "ValidationError",
  "kind": "LinkedField",
  "name": "errors",
  "plural": true,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "field",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "message",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "kind",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "color",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "cover",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "ordering",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "title",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "subtitle",
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "richEditorDescription",
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "hideAfter",
  "storageKey": null
},
v13 = {
  "alias": "richTextBlockTitle",
  "args": null,
  "kind": "ScalarField",
  "name": "title",
  "storageKey": null
},
v14 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "richEditorContent",
  "storageKey": null
},
v15 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "hasCtaButton",
  "storageKey": null
},
v16 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "ctaUrl",
  "storageKey": null
},
v17 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "ctaText",
  "storageKey": null
},
v18 = {
  "kind": "InlineFragment",
  "selections": [
    (v13/*: any*/),
    (v14/*: any*/),
    (v15/*: any*/),
    (v16/*: any*/),
    (v17/*: any*/)
  ],
  "type": "RichTextDashboardBlock",
  "abstractKey": null
},
v19 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "description",
  "storageKey": null
},
v20 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "showMembers",
  "storageKey": null
},
v21 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "showDates",
  "storageKey": null
},
v22 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "showCountdown",
  "storageKey": null
},
v23 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "showProgress",
  "storageKey": null
},
v24 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "showAttendance",
  "storageKey": null
},
v25 = {
  "kind": "InlineFragment",
  "selections": [
    (v19/*: any*/),
    (v20/*: any*/),
    (v21/*: any*/),
    (v22/*: any*/),
    (v23/*: any*/),
    (v24/*: any*/)
  ],
  "type": "ExperienceDetailsDashboardBlock",
  "abstractKey": null
},
v26 = {
  "alias": "contentMode",
  "args": null,
  "kind": "ScalarField",
  "name": "mode",
  "storageKey": null
},
v27 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "contentId",
  "storageKey": null
},
v28 = {
  "kind": "InlineFragment",
  "selections": [
    (v26/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "ContentUsageNodeConnection",
      "kind": "LinkedField",
      "name": "contentUsages",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "ContentUsageNodeEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "ContentUsage",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                (v4/*: any*/),
                (v27/*: any*/)
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "ContentDashboardBlock",
  "abstractKey": null
},
v29 = {
  "kind": "InlineFragment",
  "selections": [
    (v27/*: any*/)
  ],
  "type": "CollectionFolderDashboardBlock",
  "abstractKey": null
},
v30 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "featuredKind",
  "storageKey": null
},
v31 = [
  (v4/*: any*/)
],
v32 = {
  "alias": null,
  "args": null,
  "concreteType": "ProductNodeConnection",
  "kind": "LinkedField",
  "name": "featuredProducts",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "ProductNodeEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "Product",
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": (v31/*: any*/),
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
},
v33 = {
  "kind": "InlineFragment",
  "selections": [
    (v22/*: any*/),
    (v30/*: any*/),
    (v32/*: any*/)
  ],
  "type": "FeaturedItemsDashboardBlock",
  "abstractKey": null
},
v34 = {
  "alias": "leaderboardCount",
  "args": null,
  "kind": "ScalarField",
  "name": "count",
  "storageKey": null
},
v35 = {
  "alias": "leaderboardTitle",
  "args": null,
  "kind": "ScalarField",
  "name": "title",
  "storageKey": null
},
v36 = {
  "alias": "leaderboardDescription",
  "args": null,
  "kind": "ScalarField",
  "name": "description",
  "storageKey": null
},
v37 = {
  "alias": "leaderboardLookbackWindow",
  "args": null,
  "kind": "ScalarField",
  "name": "lookbackWindow",
  "storageKey": null
},
v38 = {
  "alias": "leaderboardView",
  "args": null,
  "kind": "ScalarField",
  "name": "view",
  "storageKey": null
},
v39 = {
  "alias": "membersListCount",
  "args": null,
  "kind": "ScalarField",
  "name": "count",
  "storageKey": null
},
v40 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "memberType",
  "storageKey": null
},
v41 = {
  "kind": "InlineFragment",
  "selections": [
    (v39/*: any*/),
    (v40/*: any*/)
  ],
  "type": "MembersListDashboardBlock",
  "abstractKey": null
},
v42 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "count",
  "storageKey": null
},
v43 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "eventType",
  "storageKey": null
},
v44 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "showCover",
  "storageKey": null
},
v45 = {
  "alias": "eventsView",
  "args": null,
  "kind": "ScalarField",
  "name": "view",
  "storageKey": null
},
v46 = {
  "kind": "InlineFragment",
  "selections": [
    (v42/*: any*/),
    (v43/*: any*/),
    (v44/*: any*/),
    (v45/*: any*/)
  ],
  "type": "UpcomingEventsDashboardBlock",
  "abstractKey": null
},
v47 = {
  "alias": "feedTitle",
  "args": null,
  "kind": "ScalarField",
  "name": "title",
  "storageKey": null
},
v48 = {
  "alias": "feedView",
  "args": null,
  "kind": "ScalarField",
  "name": "view",
  "storageKey": null
},
v49 = {
  "alias": "feedShowCover",
  "args": null,
  "kind": "ScalarField",
  "name": "showCover",
  "storageKey": null
},
v50 = {
  "kind": "InlineFragment",
  "selections": [
    (v47/*: any*/),
    (v48/*: any*/),
    (v49/*: any*/)
  ],
  "type": "FeedDashboardBlock",
  "abstractKey": null
},
v51 = {
  "alias": "curriculumTitle",
  "args": null,
  "kind": "ScalarField",
  "name": "title",
  "storageKey": null
},
v52 = {
  "alias": "curriculumView",
  "args": null,
  "kind": "ScalarField",
  "name": "view",
  "storageKey": null
},
v53 = {
  "kind": "InlineFragment",
  "selections": [
    (v51/*: any*/),
    (v52/*: any*/)
  ],
  "type": "CurriculumDashboardBlock",
  "abstractKey": null
},
v54 = {
  "alias": "channelsTitle",
  "args": null,
  "kind": "ScalarField",
  "name": "title",
  "storageKey": null
},
v55 = {
  "kind": "InlineFragment",
  "selections": [
    (v54/*: any*/)
  ],
  "type": "ChannelsDashboardBlock",
  "abstractKey": null
},
v56 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "showAvailability",
  "storageKey": null
},
v57 = {
  "kind": "InlineFragment",
  "selections": [
    (v44/*: any*/),
    (v21/*: any*/),
    (v22/*: any*/),
    (v56/*: any*/)
  ],
  "type": "BannerDashboardBlock",
  "abstractKey": null
},
v58 = {
  "kind": "InlineFragment",
  "selections": [
    (v9/*: any*/),
    (v10/*: any*/)
  ],
  "type": "CommunityWelcomeHeroDashboardBlock",
  "abstractKey": null
},
v59 = {
  "kind": "InlineFragment",
  "selections": [
    (v9/*: any*/)
  ],
  "type": "ContinueYourProductsDashboardBlock",
  "abstractKey": null
},
v60 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "organizationId",
  "storageKey": null
},
v61 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "slug",
  "storageKey": null
},
v62 = {
  "alias": null,
  "args": null,
  "concreteType": "Product",
  "kind": "LinkedField",
  "name": "product",
  "plural": false,
  "selections": [
    (v4/*: any*/),
    (v61/*: any*/)
  ],
  "storageKey": null
},
v63 = {
  "alias": "memberCount",
  "args": null,
  "kind": "ScalarField",
  "name": "count",
  "storageKey": null
},
v64 = {
  "kind": "InlineFragment",
  "selections": [
    (v44/*: any*/),
    (v21/*: any*/),
    (v22/*: any*/),
    (v56/*: any*/),
    (v7/*: any*/)
  ],
  "type": "BannerDashboardBlock",
  "abstractKey": null
},
v65 = {
  "kind": "InlineFragment",
  "selections": [
    (v10/*: any*/),
    (v7/*: any*/)
  ],
  "type": "CommunityWelcomeHeroDashboardBlock",
  "abstractKey": null
},
v66 = {
  "kind": "InlineFragment",
  "selections": [
    (v9/*: any*/),
    (v10/*: any*/),
    (v7/*: any*/)
  ],
  "type": "CommunityWelcomeHeroDashboardBlock",
  "abstractKey": null
},
v67 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "totalCount",
  "storageKey": null
},
v68 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "showComments",
  "storageKey": null
},
v69 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "hasViewerBookmarked",
  "storageKey": null
},
v70 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "customAppTitle",
  "storageKey": null
},
v71 = [
  (v70/*: any*/),
  (v4/*: any*/)
],
v72 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v73 = [
  (v72/*: any*/),
  (v4/*: any*/)
],
v74 = {
  "alias": null,
  "args": null,
  "concreteType": "Product",
  "kind": "LinkedField",
  "name": "product",
  "plural": false,
  "selections": (v73/*: any*/),
  "storageKey": null
},
v75 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "entity",
  "storageKey": null
},
v76 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "entityId",
  "storageKey": null
},
v77 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isCurriculumModule",
  "storageKey": null
},
v78 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "type",
  "storageKey": null
},
v79 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "label",
  "storageKey": null
},
v80 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "creationDatetime",
  "storageKey": null
},
v81 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "coverVideo",
  "storageKey": null
},
v82 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "thumbnailUrl",
  "storageKey": null
},
v83 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "showCoverPlayIcon",
  "storageKey": null
},
v84 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isCollectionModule",
  "storageKey": null
},
v85 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "productId",
  "storageKey": null
},
v86 = [
  (v67/*: any*/)
],
v87 = {
  "alias": null,
  "args": null,
  "concreteType": "ContentLikeNodeConnection",
  "kind": "LinkedField",
  "name": "likes",
  "plural": false,
  "selections": (v86/*: any*/),
  "storageKey": null
},
v88 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "totalComments",
  "storageKey": null
},
v89 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "hasViewerCommented",
  "storageKey": null
},
v90 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "fullName",
  "storageKey": null
},
v91 = [
  (v4/*: any*/),
  (v72/*: any*/)
],
v92 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "releasedAt",
  "storageKey": null
},
v93 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isLocked",
  "storageKey": null
},
v94 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "viewerHasCompleted",
  "storageKey": null
},
v95 = {
  "kind": "InlineFragment",
  "selections": [
    (v21/*: any*/),
    (v22/*: any*/),
    (v56/*: any*/),
    (v7/*: any*/)
  ],
  "type": "BannerDashboardBlock",
  "abstractKey": null
},
v96 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "viewerPermissions",
  "storageKey": null
},
v97 = [
  (v96/*: any*/)
],
v98 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "memberPermissions",
  "storageKey": null
},
v99 = [
  {
    "alias": "nonNullProductId",
    "args": null,
    "kind": "ScalarField",
    "name": "productId",
    "storageKey": null
  },
  (v96/*: any*/),
  (v98/*: any*/)
],
v100 = [
  {
    "alias": "nullableProductId",
    "args": null,
    "kind": "ScalarField",
    "name": "productId",
    "storageKey": null
  },
  (v96/*: any*/),
  (v98/*: any*/)
],
v101 = {
  "kind": "InlineFragment",
  "selections": [
    (v3/*: any*/),
    {
      "kind": "InlineFragment",
      "selections": (v97/*: any*/),
      "type": "Organization",
      "abstractKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "alias": "nonNullProductId",
          "args": null,
          "kind": "ScalarField",
          "name": "id",
          "storageKey": null
        },
        (v96/*: any*/),
        (v98/*: any*/)
      ],
      "type": "Product",
      "abstractKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": (v99/*: any*/),
      "type": "Event",
      "abstractKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": (v100/*: any*/),
      "type": "Comment",
      "abstractKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": (v100/*: any*/),
      "type": "Feed",
      "abstractKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": (v100/*: any*/),
      "type": "Post",
      "abstractKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "alias": "nullableProductIdString",
          "args": null,
          "kind": "ScalarField",
          "name": "productId",
          "storageKey": null
        },
        (v96/*: any*/),
        (v98/*: any*/)
      ],
      "type": "ContentUsage",
      "abstractKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": (v100/*: any*/),
      "type": "ChatChannel",
      "abstractKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": (v100/*: any*/),
      "type": "Dashboard",
      "abstractKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": (v99/*: any*/),
      "type": "AssignmentSubmission",
      "abstractKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": (v97/*: any*/),
      "type": "PathwayGroup",
      "abstractKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": (v97/*: any*/),
      "type": "BrainSearch",
      "abstractKey": null
    }
  ],
  "type": "Node",
  "abstractKey": "__isNode"
},
v102 = [
  (v4/*: any*/),
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "viewerCanPostInFeeds",
    "storageKey": null
  }
],
v103 = {
  "alias": null,
  "args": null,
  "concreteType": "Tag",
  "kind": "LinkedField",
  "name": "typeTag",
  "plural": false,
  "selections": [
    (v79/*: any*/),
    (v6/*: any*/),
    (v4/*: any*/)
  ],
  "storageKey": null
},
v104 = {
  "kind": "InlineFragment",
  "selections": [
    (v8/*: any*/)
  ],
  "type": "DashboardBlock",
  "abstractKey": "__isDashboardBlock"
},
v105 = {
  "kind": "InlineFragment",
  "selections": [
    (v8/*: any*/),
    (v59/*: any*/)
  ],
  "type": "DashboardBlock",
  "abstractKey": "__isDashboardBlock"
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "EditDashboardBlockFormMutation",
    "selections": [
      {
        "alias": "response",
        "args": (v1/*: any*/),
        "concreteType": "EditDashboardBlockResponse",
        "kind": "LinkedField",
        "name": "editDashboardBlock",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "node",
            "plural": false,
            "selections": [
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "DashboardBlockItemFragment"
              },
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "EditDashboardBlockFormFragment"
              }
            ],
            "storageKey": null
          },
          (v2/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "EditDashboardBlockFormMutation",
    "selections": [
      {
        "alias": "response",
        "args": (v1/*: any*/),
        "concreteType": "EditDashboardBlockResponse",
        "kind": "LinkedField",
        "name": "editDashboardBlock",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "node",
            "plural": false,
            "selections": [
              (v3/*: any*/),
              {
                "kind": "TypeDiscriminator",
                "abstractKey": "__isDashboardBlock"
              },
              (v4/*: any*/),
              (v5/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "position",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "showOnMobile",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "dashboardId",
                "storageKey": null
              },
              {
                "kind": "InlineFragment",
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "showWelcomeText",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "askAi",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "headerWithMacrosReplaced",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "subText",
                    "storageKey": null
                  },
                  (v6/*: any*/),
                  {
                    "alias": "heroMode",
                    "args": null,
                    "kind": "ScalarField",
                    "name": "mode",
                    "storageKey": null
                  },
                  (v7/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "textColor",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "header",
                    "storageKey": null
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      (v8/*: any*/),
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v9/*: any*/),
                          (v10/*: any*/),
                          (v11/*: any*/),
                          (v12/*: any*/)
                        ],
                        "type": "WelcomeBannerDashboardBlock",
                        "abstractKey": null
                      },
                      (v18/*: any*/),
                      (v25/*: any*/),
                      (v28/*: any*/),
                      (v29/*: any*/),
                      (v33/*: any*/),
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v34/*: any*/),
                          (v35/*: any*/),
                          (v36/*: any*/),
                          (v37/*: any*/),
                          (v38/*: any*/)
                        ],
                        "type": "LeaderboardDashboardBlock",
                        "abstractKey": null
                      },
                      (v41/*: any*/),
                      (v46/*: any*/),
                      (v50/*: any*/),
                      (v53/*: any*/),
                      (v55/*: any*/),
                      (v57/*: any*/),
                      (v58/*: any*/),
                      (v59/*: any*/)
                    ],
                    "type": "DashboardBlock",
                    "abstractKey": "__isDashboardBlock"
                  }
                ],
                "type": "HeroDashboardBlock",
                "abstractKey": null
              },
              {
                "kind": "InlineFragment",
                "selections": [
                  (v60/*: any*/),
                  (v62/*: any*/),
                  (v63/*: any*/),
                  (v9/*: any*/),
                  {
                    "alias": "blockDescription",
                    "args": null,
                    "kind": "ScalarField",
                    "name": "description",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "lookbackWindow",
                    "storageKey": null
                  },
                  {
                    "alias": "blockView",
                    "args": null,
                    "kind": "ScalarField",
                    "name": "view",
                    "storageKey": null
                  },
                  (v34/*: any*/),
                  (v35/*: any*/),
                  (v36/*: any*/),
                  (v37/*: any*/),
                  (v38/*: any*/),
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      (v8/*: any*/),
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v10/*: any*/),
                          (v11/*: any*/),
                          (v7/*: any*/),
                          (v12/*: any*/)
                        ],
                        "type": "WelcomeBannerDashboardBlock",
                        "abstractKey": null
                      },
                      (v18/*: any*/),
                      (v25/*: any*/),
                      (v28/*: any*/),
                      (v29/*: any*/),
                      (v33/*: any*/),
                      (v41/*: any*/),
                      (v46/*: any*/),
                      (v50/*: any*/),
                      (v53/*: any*/),
                      (v55/*: any*/),
                      (v64/*: any*/),
                      (v65/*: any*/)
                    ],
                    "type": "DashboardBlock",
                    "abstractKey": "__isDashboardBlock"
                  }
                ],
                "type": "LeaderboardDashboardBlock",
                "abstractKey": null
              },
              {
                "kind": "InlineFragment",
                "selections": [
                  (v9/*: any*/),
                  (v10/*: any*/),
                  (v11/*: any*/),
                  (v7/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Organization",
                    "kind": "LinkedField",
                    "name": "organization",
                    "plural": false,
                    "selections": [
                      (v7/*: any*/),
                      (v4/*: any*/)
                    ],
                    "storageKey": null
                  },
                  (v12/*: any*/),
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      (v8/*: any*/),
                      (v18/*: any*/),
                      (v25/*: any*/),
                      (v28/*: any*/),
                      (v29/*: any*/),
                      (v33/*: any*/),
                      (v41/*: any*/),
                      (v46/*: any*/),
                      (v50/*: any*/),
                      (v53/*: any*/),
                      (v55/*: any*/),
                      (v57/*: any*/)
                    ],
                    "type": "DashboardBlock",
                    "abstractKey": "__isDashboardBlock"
                  }
                ],
                "type": "WelcomeBannerDashboardBlock",
                "abstractKey": null
              },
              {
                "kind": "InlineFragment",
                "selections": [
                  (v22/*: any*/),
                  (v30/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Dashboard",
                    "kind": "LinkedField",
                    "name": "dashboard",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "layout",
                        "storageKey": null
                      },
                      (v4/*: any*/)
                    ],
                    "storageKey": null
                  },
                  (v32/*: any*/),
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      (v8/*: any*/),
                      (v18/*: any*/),
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v19/*: any*/),
                          (v20/*: any*/),
                          (v21/*: any*/),
                          (v23/*: any*/),
                          (v24/*: any*/)
                        ],
                        "type": "ExperienceDetailsDashboardBlock",
                        "abstractKey": null
                      },
                      (v28/*: any*/),
                      (v29/*: any*/),
                      (v41/*: any*/),
                      (v46/*: any*/),
                      (v50/*: any*/),
                      (v53/*: any*/),
                      (v55/*: any*/),
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v44/*: any*/),
                          (v21/*: any*/),
                          (v56/*: any*/),
                          (v7/*: any*/)
                        ],
                        "type": "BannerDashboardBlock",
                        "abstractKey": null
                      },
                      (v66/*: any*/),
                      (v59/*: any*/)
                    ],
                    "type": "DashboardBlock",
                    "abstractKey": "__isDashboardBlock"
                  }
                ],
                "type": "FeaturedItemsDashboardBlock",
                "abstractKey": null
              },
              {
                "kind": "InlineFragment",
                "selections": [
                  (v60/*: any*/),
                  (v62/*: any*/),
                  (v40/*: any*/),
                  (v63/*: any*/),
                  (v39/*: any*/),
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      (v8/*: any*/),
                      (v18/*: any*/),
                      (v25/*: any*/),
                      (v28/*: any*/),
                      (v29/*: any*/),
                      (v46/*: any*/),
                      (v50/*: any*/),
                      (v53/*: any*/),
                      (v55/*: any*/),
                      (v64/*: any*/),
                      (v66/*: any*/),
                      (v59/*: any*/)
                    ],
                    "type": "DashboardBlock",
                    "abstractKey": "__isDashboardBlock"
                  }
                ],
                "type": "MembersListDashboardBlock",
                "abstractKey": null
              },
              {
                "kind": "InlineFragment",
                "selections": [
                  (v13/*: any*/),
                  (v14/*: any*/),
                  (v15/*: any*/),
                  (v16/*: any*/),
                  (v17/*: any*/),
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      (v8/*: any*/),
                      (v25/*: any*/),
                      (v28/*: any*/),
                      (v29/*: any*/),
                      (v46/*: any*/),
                      (v50/*: any*/),
                      (v53/*: any*/),
                      (v55/*: any*/),
                      (v64/*: any*/),
                      (v66/*: any*/),
                      (v59/*: any*/)
                    ],
                    "type": "DashboardBlock",
                    "abstractKey": "__isDashboardBlock"
                  }
                ],
                "type": "RichTextDashboardBlock",
                "abstractKey": null
              },
              {
                "kind": "InlineFragment",
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "mode",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "ContentUsageNodeConnection",
                    "kind": "LinkedField",
                    "name": "contentUsages",
                    "plural": false,
                    "selections": [
                      (v67/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "ContentUsageNodeEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "ContentUsage",
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": [
                              (v4/*: any*/),
                              (v68/*: any*/),
                              (v69/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "ProductApp",
                                "kind": "LinkedField",
                                "name": "productApp",
                                "plural": false,
                                "selections": [
                                  (v70/*: any*/),
                                  (v4/*: any*/),
                                  (v5/*: any*/)
                                ],
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "Content",
                                "kind": "LinkedField",
                                "name": "module",
                                "plural": false,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "ContentUsageNodeConnection",
                                    "kind": "LinkedField",
                                    "name": "usages",
                                    "plural": false,
                                    "selections": [
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "ContentUsageNodeEdge",
                                        "kind": "LinkedField",
                                        "name": "edges",
                                        "plural": true,
                                        "selections": [
                                          {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "ContentUsage",
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                              (v4/*: any*/),
                                              {
                                                "alias": null,
                                                "args": null,
                                                "concreteType": "ProductApp",
                                                "kind": "LinkedField",
                                                "name": "productApp",
                                                "plural": false,
                                                "selections": (v71/*: any*/),
                                                "storageKey": null
                                              },
                                              {
                                                "alias": null,
                                                "args": null,
                                                "concreteType": "Collection",
                                                "kind": "LinkedField",
                                                "name": "collection",
                                                "plural": false,
                                                "selections": [
                                                  (v4/*: any*/),
                                                  {
                                                    "alias": null,
                                                    "args": null,
                                                    "concreteType": "ProductApp",
                                                    "kind": "LinkedField",
                                                    "name": "app",
                                                    "plural": false,
                                                    "selections": (v71/*: any*/),
                                                    "storageKey": null
                                                  }
                                                ],
                                                "storageKey": null
                                              },
                                              {
                                                "alias": null,
                                                "args": null,
                                                "concreteType": "Curriculum",
                                                "kind": "LinkedField",
                                                "name": "curriculum",
                                                "plural": false,
                                                "selections": [
                                                  (v4/*: any*/),
                                                  (v74/*: any*/)
                                                ],
                                                "storageKey": null
                                              },
                                              (v75/*: any*/),
                                              (v76/*: any*/)
                                            ],
                                            "storageKey": null
                                          }
                                        ],
                                        "storageKey": null
                                      }
                                    ],
                                    "storageKey": null
                                  },
                                  (v4/*: any*/),
                                  (v77/*: any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "ContentUsageNodeConnection",
                                    "kind": "LinkedField",
                                    "name": "children",
                                    "plural": false,
                                    "selections": [
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "ContentUsageNodeEdge",
                                        "kind": "LinkedField",
                                        "name": "edges",
                                        "plural": true,
                                        "selections": [
                                          {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "ContentUsage",
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                              (v4/*: any*/),
                                              {
                                                "alias": null,
                                                "args": null,
                                                "concreteType": "Content",
                                                "kind": "LinkedField",
                                                "name": "content",
                                                "plural": false,
                                                "selections": [
                                                  (v4/*: any*/),
                                                  (v78/*: any*/),
                                                  (v72/*: any*/),
                                                  {
                                                    "alias": null,
                                                    "args": null,
                                                    "kind": "ScalarField",
                                                    "name": "systemTaskKind",
                                                    "storageKey": null
                                                  },
                                                  (v79/*: any*/),
                                                  (v80/*: any*/),
                                                  (v81/*: any*/),
                                                  (v82/*: any*/),
                                                  (v83/*: any*/)
                                                ],
                                                "storageKey": null
                                              }
                                            ],
                                            "storageKey": null
                                          }
                                        ],
                                        "storageKey": null
                                      }
                                    ],
                                    "storageKey": null
                                  },
                                  (v84/*: any*/)
                                ],
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "Content",
                                "kind": "LinkedField",
                                "name": "content",
                                "plural": false,
                                "selections": [
                                  (v4/*: any*/),
                                  (v78/*: any*/),
                                  (v79/*: any*/),
                                  (v72/*: any*/),
                                  (v19/*: any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "coverPhoto",
                                    "storageKey": null
                                  },
                                  (v81/*: any*/),
                                  (v82/*: any*/),
                                  (v83/*: any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "AssetUsage",
                                    "kind": "LinkedField",
                                    "name": "coverVideoAssetUsage",
                                    "plural": false,
                                    "selections": [
                                      (v4/*: any*/),
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "Asset",
                                        "kind": "LinkedField",
                                        "name": "asset",
                                        "plural": false,
                                        "selections": [
                                          (v4/*: any*/),
                                          {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "url",
                                            "storageKey": null
                                          },
                                          (v72/*: any*/),
                                          {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "muxAssetPlaybackId",
                                            "storageKey": null
                                          },
                                          {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "aspectRatio",
                                            "storageKey": null
                                          },
                                          {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "videoDuration",
                                            "storageKey": null
                                          }
                                        ],
                                        "storageKey": null
                                      }
                                    ],
                                    "storageKey": null
                                  },
                                  (v85/*: any*/),
                                  (v69/*: any*/),
                                  (v68/*: any*/),
                                  (v87/*: any*/),
                                  (v88/*: any*/),
                                  (v89/*: any*/),
                                  (v77/*: any*/),
                                  {
                                    "alias": "allChildren",
                                    "args": null,
                                    "concreteType": "ContentUsageNodeConnection",
                                    "kind": "LinkedField",
                                    "name": "children",
                                    "plural": false,
                                    "selections": [
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "ContentUsageNodeEdge",
                                        "kind": "LinkedField",
                                        "name": "edges",
                                        "plural": true,
                                        "selections": [
                                          {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "ContentUsage",
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": (v31/*: any*/),
                                            "storageKey": null
                                          }
                                        ],
                                        "storageKey": null
                                      }
                                    ],
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "User",
                                    "kind": "LinkedField",
                                    "name": "createdBy",
                                    "plural": false,
                                    "selections": [
                                      (v4/*: any*/),
                                      (v90/*: any*/),
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "avatar",
                                        "storageKey": null
                                      },
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "isTest",
                                        "storageKey": null
                                      }
                                    ],
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "Product",
                                    "kind": "LinkedField",
                                    "name": "product",
                                    "plural": false,
                                    "selections": [
                                      (v72/*: any*/),
                                      (v61/*: any*/),
                                      (v4/*: any*/)
                                    ],
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "releaseDatetime",
                                    "storageKey": null
                                  },
                                  (v80/*: any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "Post",
                                    "kind": "LinkedField",
                                    "name": "post",
                                    "plural": false,
                                    "selections": [
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "Feed",
                                        "kind": "LinkedField",
                                        "name": "feed",
                                        "plural": false,
                                        "selections": (v91/*: any*/),
                                        "storageKey": null
                                      },
                                      (v92/*: any*/),
                                      (v4/*: any*/)
                                    ],
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "richEditorDescriptionContent",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "ContentMentionNodeConnection",
                                    "kind": "LinkedField",
                                    "name": "mentions",
                                    "plural": false,
                                    "selections": [
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "ContentMentionNodeEdge",
                                        "kind": "LinkedField",
                                        "name": "edges",
                                        "plural": true,
                                        "selections": [
                                          {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "ContentMention",
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                              (v4/*: any*/),
                                              {
                                                "alias": null,
                                                "args": null,
                                                "concreteType": "User",
                                                "kind": "LinkedField",
                                                "name": "user",
                                                "plural": false,
                                                "selections": [
                                                  (v4/*: any*/),
                                                  (v90/*: any*/)
                                                ],
                                                "storageKey": null
                                              },
                                              {
                                                "alias": null,
                                                "args": null,
                                                "concreteType": "MemberGroup",
                                                "kind": "LinkedField",
                                                "name": "memberGroup",
                                                "plural": false,
                                                "selections": [
                                                  (v4/*: any*/),
                                                  (v72/*: any*/),
                                                  (v5/*: any*/),
                                                  {
                                                    "alias": null,
                                                    "args": null,
                                                    "kind": "ScalarField",
                                                    "name": "role",
                                                    "storageKey": null
                                                  }
                                                ],
                                                "storageKey": null
                                              },
                                              {
                                                "alias": null,
                                                "args": null,
                                                "concreteType": "Product",
                                                "kind": "LinkedField",
                                                "name": "mentionedProduct",
                                                "plural": false,
                                                "selections": (v91/*: any*/),
                                                "storageKey": null
                                              },
                                              {
                                                "alias": null,
                                                "args": null,
                                                "concreteType": "ContentUsage",
                                                "kind": "LinkedField",
                                                "name": "mentionedContentUsage",
                                                "plural": false,
                                                "selections": [
                                                  (v4/*: any*/),
                                                  {
                                                    "alias": null,
                                                    "args": null,
                                                    "concreteType": "Content",
                                                    "kind": "LinkedField",
                                                    "name": "content",
                                                    "plural": false,
                                                    "selections": (v91/*: any*/),
                                                    "storageKey": null
                                                  }
                                                ],
                                                "storageKey": null
                                              },
                                              {
                                                "alias": null,
                                                "args": null,
                                                "concreteType": "Occurrence",
                                                "kind": "LinkedField",
                                                "name": "mentionedOccurrence",
                                                "plural": false,
                                                "selections": [
                                                  (v4/*: any*/),
                                                  (v72/*: any*/),
                                                  {
                                                    "alias": null,
                                                    "args": null,
                                                    "concreteType": "Content",
                                                    "kind": "LinkedField",
                                                    "name": "content",
                                                    "plural": false,
                                                    "selections": (v73/*: any*/),
                                                    "storageKey": null
                                                  }
                                                ],
                                                "storageKey": null
                                              }
                                            ],
                                            "storageKey": null
                                          }
                                        ],
                                        "storageKey": null
                                      },
                                      {
                                        "kind": "ClientExtension",
                                        "selections": [
                                          {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "__id",
                                            "storageKey": null
                                          }
                                        ]
                                      }
                                    ],
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "ContentAttachmentNodeConnection",
                                    "kind": "LinkedField",
                                    "name": "attachments",
                                    "plural": false,
                                    "selections": [
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "ContentAttachmentNodeEdge",
                                        "kind": "LinkedField",
                                        "name": "edges",
                                        "plural": true,
                                        "selections": [
                                          {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "ContentAttachment",
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                              (v4/*: any*/),
                                              (v72/*: any*/),
                                              (v78/*: any*/),
                                              {
                                                "alias": null,
                                                "args": null,
                                                "kind": "ScalarField",
                                                "name": "downloadUrl",
                                                "storageKey": null
                                              },
                                              {
                                                "alias": null,
                                                "args": null,
                                                "kind": "ScalarField",
                                                "name": "videoUrl",
                                                "storageKey": null
                                              },
                                              {
                                                "alias": null,
                                                "args": null,
                                                "kind": "ScalarField",
                                                "name": "mediaUrl",
                                                "storageKey": null
                                              }
                                            ],
                                            "storageKey": null
                                          }
                                        ],
                                        "storageKey": null
                                      }
                                    ],
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              },
                              (v93/*: any*/),
                              (v75/*: any*/),
                              (v76/*: any*/),
                              (v85/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "ContentUsageNodeConnection",
                                "kind": "LinkedField",
                                "name": "dependents",
                                "plural": false,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "ContentUsageNodeEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "ContentUsage",
                                        "kind": "LinkedField",
                                        "name": "node",
                                        "plural": false,
                                        "selections": [
                                          (v4/*: any*/),
                                          {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "Content",
                                            "kind": "LinkedField",
                                            "name": "content",
                                            "plural": false,
                                            "selections": [
                                              (v77/*: any*/),
                                              (v4/*: any*/),
                                              (v78/*: any*/),
                                              (v79/*: any*/),
                                              (v72/*: any*/),
                                              (v80/*: any*/),
                                              (v81/*: any*/),
                                              (v82/*: any*/),
                                              (v83/*: any*/),
                                              (v19/*: any*/),
                                              {
                                                "alias": null,
                                                "args": null,
                                                "concreteType": "ContentUsageNodeConnection",
                                                "kind": "LinkedField",
                                                "name": "children",
                                                "plural": false,
                                                "selections": [
                                                  (v67/*: any*/),
                                                  {
                                                    "alias": null,
                                                    "args": null,
                                                    "concreteType": "ContentUsageNodeEdge",
                                                    "kind": "LinkedField",
                                                    "name": "edges",
                                                    "plural": true,
                                                    "selections": [
                                                      {
                                                        "alias": null,
                                                        "args": null,
                                                        "concreteType": "ContentUsage",
                                                        "kind": "LinkedField",
                                                        "name": "node",
                                                        "plural": false,
                                                        "selections": [
                                                          (v4/*: any*/),
                                                          (v94/*: any*/),
                                                          {
                                                            "alias": null,
                                                            "args": null,
                                                            "concreteType": "Content",
                                                            "kind": "LinkedField",
                                                            "name": "content",
                                                            "plural": false,
                                                            "selections": [
                                                              (v78/*: any*/),
                                                              {
                                                                "alias": null,
                                                                "args": null,
                                                                "kind": "ScalarField",
                                                                "name": "contentLabelId",
                                                                "storageKey": null
                                                              },
                                                              (v4/*: any*/)
                                                            ],
                                                            "storageKey": null
                                                          }
                                                        ],
                                                        "storageKey": null
                                                      }
                                                    ],
                                                    "storageKey": null
                                                  }
                                                ],
                                                "storageKey": null
                                              }
                                            ],
                                            "storageKey": null
                                          },
                                          (v92/*: any*/),
                                          (v94/*: any*/),
                                          {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "dueAt",
                                            "storageKey": null
                                          },
                                          (v75/*: any*/),
                                          (v74/*: any*/),
                                          {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "Content",
                                            "kind": "LinkedField",
                                            "name": "module",
                                            "plural": false,
                                            "selections": [
                                              (v77/*: any*/),
                                              (v84/*: any*/),
                                              (v72/*: any*/),
                                              (v4/*: any*/)
                                            ],
                                            "storageKey": null
                                          },
                                          (v93/*: any*/),
                                          {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "passPercentage",
                                            "storageKey": null
                                          },
                                          (v76/*: any*/)
                                        ],
                                        "storageKey": null
                                      }
                                    ],
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              },
                              (v27/*: any*/),
                              (v87/*: any*/),
                              (v88/*: any*/),
                              (v89/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "Product",
                                "kind": "LinkedField",
                                "name": "product",
                                "plural": false,
                                "selections": [
                                  (v61/*: any*/),
                                  (v4/*: any*/)
                                ],
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  (v26/*: any*/),
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      (v8/*: any*/),
                      (v25/*: any*/),
                      (v29/*: any*/),
                      (v46/*: any*/),
                      (v50/*: any*/),
                      (v53/*: any*/),
                      (v55/*: any*/),
                      (v64/*: any*/),
                      (v66/*: any*/),
                      (v59/*: any*/)
                    ],
                    "type": "DashboardBlock",
                    "abstractKey": "__isDashboardBlock"
                  }
                ],
                "type": "ContentDashboardBlock",
                "abstractKey": null
              },
              {
                "kind": "InlineFragment",
                "selections": [
                  (v19/*: any*/),
                  (v20/*: any*/),
                  (v21/*: any*/),
                  (v22/*: any*/),
                  (v23/*: any*/),
                  (v24/*: any*/),
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      (v8/*: any*/),
                      (v29/*: any*/),
                      (v46/*: any*/),
                      (v50/*: any*/),
                      (v53/*: any*/),
                      (v55/*: any*/),
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v44/*: any*/),
                          (v56/*: any*/),
                          (v7/*: any*/)
                        ],
                        "type": "BannerDashboardBlock",
                        "abstractKey": null
                      },
                      (v66/*: any*/),
                      (v59/*: any*/)
                    ],
                    "type": "DashboardBlock",
                    "abstractKey": "__isDashboardBlock"
                  }
                ],
                "type": "ExperienceDetailsDashboardBlock",
                "abstractKey": null
              },
              {
                "kind": "InlineFragment",
                "selections": [
                  (v45/*: any*/),
                  (v85/*: any*/),
                  (v60/*: any*/),
                  (v44/*: any*/),
                  (v42/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "view",
                    "storageKey": null
                  },
                  (v43/*: any*/),
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      (v8/*: any*/),
                      (v29/*: any*/),
                      (v50/*: any*/),
                      (v53/*: any*/),
                      (v55/*: any*/),
                      (v95/*: any*/),
                      (v66/*: any*/),
                      (v59/*: any*/)
                    ],
                    "type": "DashboardBlock",
                    "abstractKey": "__isDashboardBlock"
                  }
                ],
                "type": "UpcomingEventsDashboardBlock",
                "abstractKey": null
              },
              {
                "kind": "InlineFragment",
                "selections": [
                  (v48/*: any*/),
                  (v9/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "filter",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Dashboard",
                    "kind": "LinkedField",
                    "name": "dashboard",
                    "plural": false,
                    "selections": [
                      (v101/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "ProductApp",
                        "kind": "LinkedField",
                        "name": "app",
                        "plural": false,
                        "selections": [
                          (v4/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "Feed",
                            "kind": "LinkedField",
                            "name": "feed",
                            "plural": false,
                            "selections": [
                              (v4/*: any*/),
                              (v101/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "isInactive",
                                "storageKey": null
                              },
                              (v85/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "ProductApp",
                                "kind": "LinkedField",
                                "name": "app",
                                "plural": false,
                                "selections": [
                                  (v4/*: any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "visibility",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "customAppDescription",
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "Product",
                                "kind": "LinkedField",
                                "name": "product",
                                "plural": false,
                                "selections": [
                                  (v101/*: any*/),
                                  (v4/*: any*/)
                                ],
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      (v4/*: any*/)
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Organization",
                    "kind": "LinkedField",
                    "name": "organization",
                    "plural": false,
                    "selections": (v102/*: any*/),
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Product",
                    "kind": "LinkedField",
                    "name": "product",
                    "plural": false,
                    "selections": (v102/*: any*/),
                    "storageKey": null
                  },
                  (v44/*: any*/),
                  (v47/*: any*/),
                  (v49/*: any*/),
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      (v8/*: any*/),
                      (v29/*: any*/),
                      (v53/*: any*/),
                      (v55/*: any*/),
                      (v95/*: any*/),
                      (v65/*: any*/)
                    ],
                    "type": "DashboardBlock",
                    "abstractKey": "__isDashboardBlock"
                  }
                ],
                "type": "FeedDashboardBlock",
                "abstractKey": null
              },
              {
                "kind": "InlineFragment",
                "selections": [
                  (v52/*: any*/),
                  (v85/*: any*/),
                  (v60/*: any*/),
                  (v9/*: any*/),
                  (v51/*: any*/),
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      (v8/*: any*/),
                      (v29/*: any*/),
                      (v55/*: any*/),
                      (v64/*: any*/),
                      (v65/*: any*/)
                    ],
                    "type": "DashboardBlock",
                    "abstractKey": "__isDashboardBlock"
                  }
                ],
                "type": "CurriculumDashboardBlock",
                "abstractKey": null
              },
              {
                "kind": "InlineFragment",
                "selections": [
                  (v85/*: any*/),
                  (v9/*: any*/),
                  (v54/*: any*/),
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      (v8/*: any*/),
                      (v29/*: any*/),
                      (v64/*: any*/),
                      (v65/*: any*/)
                    ],
                    "type": "DashboardBlock",
                    "abstractKey": "__isDashboardBlock"
                  }
                ],
                "type": "ChannelsDashboardBlock",
                "abstractKey": null
              },
              {
                "kind": "InlineFragment",
                "selections": [
                  (v44/*: any*/),
                  (v7/*: any*/),
                  (v21/*: any*/),
                  (v22/*: any*/),
                  (v56/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Product",
                    "kind": "LinkedField",
                    "name": "product",
                    "plural": false,
                    "selections": [
                      (v103/*: any*/),
                      (v4/*: any*/)
                    ],
                    "storageKey": null
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      (v8/*: any*/),
                      (v29/*: any*/),
                      (v58/*: any*/),
                      (v59/*: any*/)
                    ],
                    "type": "DashboardBlock",
                    "abstractKey": "__isDashboardBlock"
                  }
                ],
                "type": "BannerDashboardBlock",
                "abstractKey": null
              },
              {
                "kind": "InlineFragment",
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Content",
                    "kind": "LinkedField",
                    "name": "content",
                    "plural": false,
                    "selections": (v31/*: any*/),
                    "storageKey": null
                  },
                  (v27/*: any*/),
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      (v8/*: any*/),
                      (v66/*: any*/),
                      (v59/*: any*/)
                    ],
                    "type": "DashboardBlock",
                    "abstractKey": "__isDashboardBlock"
                  }
                ],
                "type": "CollectionFolderDashboardBlock",
                "abstractKey": null
              },
              {
                "kind": "InlineFragment",
                "selections": [
                  (v9/*: any*/),
                  (v10/*: any*/),
                  (v7/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Organization",
                    "kind": "LinkedField",
                    "name": "organization",
                    "plural": false,
                    "selections": [
                      {
                        "alias": "plans",
                        "args": [
                          {
                            "kind": "Literal",
                            "name": "hideDrafts",
                            "value": true
                          },
                          {
                            "kind": "Literal",
                            "name": "type",
                            "value": "membership_plan"
                          }
                        ],
                        "concreteType": "ProductNodeConnection",
                        "kind": "LinkedField",
                        "name": "products",
                        "plural": false,
                        "selections": (v86/*: any*/),
                        "storageKey": "products(hideDrafts:true,type:\"membership_plan\")"
                      },
                      (v4/*: any*/)
                    ],
                    "storageKey": null
                  },
                  (v104/*: any*/)
                ],
                "type": "CommunityWelcomeHeroDashboardBlock",
                "abstractKey": null
              },
              {
                "kind": "InlineFragment",
                "selections": [
                  (v85/*: any*/),
                  (v21/*: any*/),
                  (v22/*: any*/),
                  (v56/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Product",
                    "kind": "LinkedField",
                    "name": "product",
                    "plural": false,
                    "selections": [
                      (v78/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "ProductNodeConnection",
                        "kind": "LinkedField",
                        "name": "childProducts",
                        "plural": false,
                        "selections": (v86/*: any*/),
                        "storageKey": null
                      },
                      (v103/*: any*/),
                      (v4/*: any*/)
                    ],
                    "storageKey": null
                  },
                  (v105/*: any*/)
                ],
                "type": "ProductAdminDashboardBlock",
                "abstractKey": null
              },
              {
                "kind": "InlineFragment",
                "selections": [
                  (v85/*: any*/),
                  (v105/*: any*/)
                ],
                "type": "PathwaySequenceDashboardBlock",
                "abstractKey": null
              },
              {
                "kind": "InlineFragment",
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "ProductNodeConnection",
                    "kind": "LinkedField",
                    "name": "products",
                    "plural": false,
                    "selections": (v86/*: any*/),
                    "storageKey": null
                  },
                  (v9/*: any*/),
                  (v104/*: any*/)
                ],
                "type": "ContinueYourProductsDashboardBlock",
                "abstractKey": null
              },
              {
                "kind": "InlineFragment",
                "selections": [
                  (v104/*: any*/)
                ],
                "type": "RecentlyViewedDashboardBlock",
                "abstractKey": null
              }
            ],
            "storageKey": null
          },
          (v2/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "b75f7c42b227a0f6058f40554c596e88",
    "id": null,
    "metadata": {},
    "name": "EditDashboardBlockFormMutation",
    "operationKind": "mutation",
    "text": "mutation EditDashboardBlockFormMutation(\n  $input: EditDashboardBlockInput!\n) {\n  response: editDashboardBlock(input: $input) {\n    node {\n      __typename\n      ...DashboardBlockItemFragment\n      ...EditDashboardBlockFormFragment\n      id\n    }\n    errors {\n      field\n      message\n    }\n  }\n}\n\nfragment AIFeedEmptyStateFragment on Feed {\n  id\n  productId\n  app {\n    id\n    visibility\n    customAppDescription\n    ...FeedAppSettingsButtonFragment\n  }\n  product {\n    ...usePermissionsFragment\n    id\n  }\n}\n\nfragment BannerDashboardBlockFragment on BannerDashboardBlock {\n  id\n  showCover\n  cover\n  ...DashboardBlockAdminDropdownFragment\n  ...ExperienceInfoToolbarFragment\n  ...DashboardBlockItemTemplateFragment\n}\n\nfragment BookmarkButtonContentFragment on Content {\n  id\n  hasViewerBookmarked\n}\n\nfragment BookmarkButtonContentUsageFragment on ContentUsage {\n  id\n  hasViewerBookmarked\n}\n\nfragment ChannelsDashboardBlockFragment on ChannelsDashboardBlock {\n  productId\n  title\n  position\n  ...DashboardBlockAdminDropdownFragment\n  ...DashboardBlockItemTemplateFragment\n}\n\nfragment CollectionFolderDashboardBlockContentFragment on CollectionFolderDashboardBlock {\n  position\n  contentId\n  ...DashboardBlockAdminDropdownFragment\n}\n\nfragment CollectionFolderDashboardBlockFragment on CollectionFolderDashboardBlock {\n  content {\n    id\n  }\n  ...DashboardBlockItemTemplateFragment\n  ...CollectionFolderDashboardBlockContentFragment\n}\n\nfragment CommentUtils_useTotalCommentsCount on Content {\n  totalComments\n}\n\nfragment CommentUtils_useTotalCommentsOnUsageCount on ContentUsage {\n  totalComments\n}\n\nfragment CommunityWelcomeHeroDashboardBlockFragment on CommunityWelcomeHeroDashboardBlock {\n  title\n  subtitle\n  cover\n  ...DashboardBlockAdminDropdownFragment\n  ...DashboardBlockItemTemplateFragment\n  organization {\n    plans: products(type: \"membership_plan\", hideDrafts: true) {\n      totalCount\n    }\n    id\n  }\n}\n\nfragment ContentAttachmentsSectionFragment on Content {\n  attachments {\n    edges {\n      node {\n        id\n        name\n        type\n        downloadUrl\n        videoUrl\n        mediaUrl\n      }\n    }\n  }\n}\n\nfragment ContentCard_ContentFragment on Content {\n  id\n  coverVideo\n  coverVideoAssetUsage {\n    id\n    asset {\n      id\n      ...DiscoVideoFragment\n    }\n  }\n  coverPhoto\n  thumbnailUrl\n  showCoverPlayIcon\n  ...ContentHeaderSectionFragment\n  ...ContentMediaSectionFragment\n  ...ContentTitleSectionFragment\n  ...ContentDescriptionSectionFragment\n  ...ContentAttachmentsSectionFragment\n  ...ContentFooterSection_ContentFragment\n  ...BookmarkButtonContentFragment\n}\n\nfragment ContentCard_ContentUsageFragment on ContentUsage {\n  id\n  ...ContentFooterSection_ContentUsageFragment\n}\n\nfragment ContentCommentButton_ContentFragment on Content {\n  ...CommentUtils_useTotalCommentsCount\n  hasViewerCommented\n}\n\nfragment ContentCommentButton_ContentUsageFragment on ContentUsage {\n  ...CommentUtils_useTotalCommentsOnUsageCount\n  hasViewerCommented\n}\n\nfragment ContentDashboardBlockAdminDropdownFragment on ContentDashboardBlock {\n  ...DashboardBlockAdminDropdownFragment\n}\n\nfragment ContentDashboardBlockFragment on ContentDashboardBlock {\n  mode\n  contentUsages {\n    totalCount\n  }\n  ...DashboardBlockItemTemplateFragment\n  ...ContentDashboardBlockPreviewContentFragment\n  ...ContentDashboardBlockFullContentFragment\n}\n\nfragment ContentDashboardBlockFullContentFragment on ContentDashboardBlock {\n  contentUsages {\n    edges {\n      node {\n        id\n        ...ContentCard_ContentUsageFragment\n        content {\n          id\n          coverPhoto\n          coverVideo\n          coverVideoAssetUsage {\n            id\n            asset {\n              id\n              ...DiscoVideoFragment\n            }\n          }\n          ...ContentCard_ContentFragment\n          ...ContentTitleSectionFragment\n        }\n      }\n    }\n  }\n  ...ContentDashboardBlockAdminDropdownFragment\n}\n\nfragment ContentDashboardBlockPreviewContentFragment on ContentDashboardBlock {\n  position\n  contentUsages {\n    edges {\n      node {\n        id\n        ...ContentUsageGridItemFragment\n      }\n    }\n  }\n  ...ContentDashboardBlockAdminDropdownFragment\n}\n\nfragment ContentDescriptionSectionFragment on Content {\n  id\n  richEditorDescriptionContent\n  type\n  ...DiscoEditorMentionsFragment\n}\n\nfragment ContentFooterSection_ContentFragment on Content {\n  id\n  hasViewerBookmarked\n  showComments\n  ...ContentReactionButton_ContentFragment\n  ...ContentCommentButton_ContentFragment\n  ...BookmarkButtonContentFragment\n}\n\nfragment ContentFooterSection_ContentUsageFragment on ContentUsage {\n  id\n  contentId\n  hasViewerBookmarked\n  showComments\n  ...ContentReactionButton_ContentUsageFragment\n  ...ContentCommentButton_ContentUsageFragment\n  ...BookmarkButtonContentUsageFragment\n}\n\nfragment ContentHeaderSectionFragment on Content {\n  id\n  type\n  createdBy {\n    id\n    ...ProfileAvatarWithDetailsFragment\n  }\n  product {\n    name\n    slug\n    id\n  }\n  releaseDatetime\n  creationDatetime\n  post {\n    feed {\n      id\n      name\n    }\n    releasedAt\n    id\n  }\n}\n\nfragment ContentMediaSectionFragment on Content {\n  id\n  coverPhoto\n  coverVideo\n  coverVideoAssetUsage {\n    id\n    asset {\n      id\n      ...DiscoVideoFragment\n    }\n  }\n}\n\nfragment ContentReactionButton_ContentFragment on Content {\n  id\n  likes {\n    totalCount\n  }\n}\n\nfragment ContentReactionButton_ContentUsageFragment on ContentUsage {\n  id\n  likes {\n    totalCount\n  }\n}\n\nfragment ContentThumbnailWithDetails_ContentFragment on Content {\n  id\n  type\n  label\n  name\n  creationDatetime\n  ...ContentThumbnail_ContentFragment\n}\n\nfragment ContentThumbnailWithDetails_ContentUsageFragment on ContentUsage {\n  id\n  dueAt\n  entity\n  product {\n    name\n    id\n  }\n  module {\n    isCurriculumModule\n    isCollectionModule\n    name\n    id\n  }\n}\n\nfragment ContentThumbnail_ContentFragment on Content {\n  id\n  type\n  coverVideo\n  thumbnailUrl\n  showCoverPlayIcon\n}\n\nfragment ContentTitleSectionFragment on Content {\n  id\n  name\n}\n\nfragment ContentUsageGridItemFragment on ContentUsage {\n  id\n  showComments\n  hasViewerBookmarked\n  productApp {\n    customAppTitle\n    id\n  }\n  ...BookmarkButtonContentUsageFragment\n  module {\n    usages {\n      edges {\n        node {\n          id\n          productApp {\n            customAppTitle\n            id\n          }\n          collection {\n            id\n            app {\n              customAppTitle\n              id\n            }\n          }\n          curriculum {\n            id\n            product {\n              name\n              id\n            }\n          }\n        }\n      }\n    }\n    id\n  }\n  content {\n    id\n    type\n    label\n    name\n    description\n    coverPhoto\n    coverVideo\n    thumbnailUrl\n    showCoverPlayIcon\n    coverVideoAssetUsage {\n      id\n      asset {\n        id\n        ...DiscoVideoFragment\n      }\n    }\n    productId\n    ...ContentFooterSection_ContentFragment\n    ...BookmarkButtonContentFragment\n  }\n  ...DeleteContentUsageButtonFragment\n  ...ContentFooterSection_ContentUsageFragment\n  ...ContentUsageUtils_useContentUsagePathContentUsageFragment\n}\n\nfragment ContentUsagePrerequisiteItemFragment on ContentUsage {\n  id\n  releasedAt\n  viewerHasCompleted\n  ...ContentThumbnailWithDetails_ContentUsageFragment\n  isLocked\n  passPercentage\n  content {\n    id\n    isCurriculumModule\n    ...ContentThumbnailWithDetails_ContentFragment\n    name\n    type\n    description\n    children {\n      totalCount\n      edges {\n        node {\n          id\n          viewerHasCompleted\n          content {\n            type\n            contentLabelId\n            id\n          }\n        }\n      }\n    }\n  }\n}\n\nfragment ContentUsageUtils_UseParentEntityContentUsageFragment on ContentUsage {\n  id\n  entity\n  module {\n    isCurriculumModule\n    isCollectionModule\n    id\n  }\n  productApp {\n    kind\n    id\n  }\n}\n\nfragment ContentUsageUtils_useContentUsagePathContentUsageFragment on ContentUsage {\n  id\n  entity\n  entityId\n  product {\n    slug\n    id\n  }\n  productApp {\n    kind\n    id\n  }\n  module {\n    usages {\n      edges {\n        node {\n          id\n          entity\n          entityId\n        }\n      }\n    }\n    id\n  }\n}\n\nfragment ContentUsageUtils_useNavigateToNextContentUsageFragment on ContentUsage {\n  id\n  module {\n    children {\n      edges {\n        node {\n          id\n          content {\n            id\n            type\n            name\n            systemTaskKind\n            ...ContentThumbnailWithDetails_ContentFragment\n          }\n        }\n      }\n    }\n    id\n  }\n}\n\nfragment ContinueYourProductsDashboardBlockFragment on ContinueYourProductsDashboardBlock {\n  id\n  position\n  products {\n    totalCount\n  }\n  ...DashboardBlockItemTemplateFragment\n  ...DashboardBlockAdminDropdownFragment\n}\n\nfragment CurriculumDashboardBlockCardViewFragment on CurriculumDashboardBlock {\n  productId\n  organizationId\n  position\n  title\n  ...DashboardBlockAdminDropdownFragment\n  ...DashboardBlockItemTemplateFragment\n}\n\nfragment CurriculumDashboardBlockFragment on CurriculumDashboardBlock {\n  curriculumView: view\n  ...DashboardBlockItemTemplateFragment\n  ...CurriculumDashboardBlockCardViewFragment\n  ...CurriculumDashboardBlockListViewFragment\n}\n\nfragment CurriculumDashboardBlockListViewFragment on CurriculumDashboardBlock {\n  productId\n  title\n  ...DashboardBlockAdminDropdownFragment\n  ...DashboardBlockItemTemplateFragment\n}\n\nfragment DashboardBlockAdminDropdownFragment on DashboardBlock {\n  __isDashboardBlock: __typename\n  id\n  position\n  kind\n  ...EditDashboardBlockButtonFragment\n}\n\nfragment DashboardBlockItemFragment on DashboardBlock {\n  __isDashboardBlock: __typename\n  id\n  kind\n  position\n  ...HeroDashboardBlockFragment\n  ...LeaderboardDashboardBlockFragment\n  ...WelcomeBannerDashboardBlockFragment\n  ...FeaturedItemsDashboardBlockFragment\n  ...MembersDashboardBlockFragment\n  ...RichTextDashboardBlockFragment\n  ...ContentDashboardBlockFragment\n  ...ExperienceDetailsDashboardBlockFragment\n  ...EventsDashboardBlockFragment\n  ...FeedDashboardBlockFragment\n  ...CurriculumDashboardBlockFragment\n  ...ChannelsDashboardBlockFragment\n  ...BannerDashboardBlockFragment\n  ...CollectionFolderDashboardBlockFragment\n  ...CommunityWelcomeHeroDashboardBlockFragment\n  ...ProductAdminDashboardBlockFragment\n  ...PathwaySequenceDashboardBlockFragment\n  ...ContinueYourProductsDashboardBlockFragment\n  ...RecentlyViewedDashboardBlockFragment\n}\n\nfragment DashboardBlockItemTemplateFragment on DashboardBlock {\n  __isDashboardBlock: __typename\n  id\n  kind\n  position\n  showOnMobile\n  ordering\n  dashboardId\n  ...DashboardBlockAdminDropdownFragment\n  ... on WelcomeBannerDashboardBlock {\n    hideAfter\n  }\n  ... on FeedDashboardBlock {\n    feedView: view\n  }\n}\n\nfragment DeleteContentUsageButtonFragment on ContentUsage {\n  id\n  isLocked\n  entity\n  entityId\n  productId\n  dependents {\n    edges {\n      node {\n        id\n        content {\n          isCurriculumModule\n          id\n        }\n        ...ContentUsagePrerequisiteItemFragment\n        ...UpdateContentModuleButtonFragment\n      }\n    }\n  }\n  module {\n    isCurriculumModule\n    id\n  }\n  content {\n    type\n    label\n    isCurriculumModule\n    allChildren: children {\n      edges {\n        node {\n          id\n        }\n      }\n    }\n    id\n  }\n  productApp {\n    customAppTitle\n    id\n  }\n  ...ContentUsageUtils_useNavigateToNextContentUsageFragment\n  ...ContentUsageUtils_UseParentEntityContentUsageFragment\n}\n\nfragment DiscoEditorMentionsFragment on Content {\n  id\n  ...EditorMentionsProviderFragment\n}\n\nfragment DiscoVideoFragment on Asset {\n  id\n  url\n  name\n  muxAssetPlaybackId\n  aspectRatio\n  videoDuration\n}\n\nfragment EditDashboardBlockButtonFragment on DashboardBlock {\n  __isDashboardBlock: __typename\n  kind\n  position\n  ...EditDashboardBlockFormFragment\n}\n\nfragment EditDashboardBlockFormFragment on DashboardBlock {\n  __isDashboardBlock: __typename\n  id\n  kind\n  position\n  showOnMobile\n  dashboardId\n  __typename\n  ... on WelcomeBannerDashboardBlock {\n    title\n    subtitle\n    richEditorDescription\n    cover\n    hideAfter\n  }\n  ... on RichTextDashboardBlock {\n    position\n    richTextBlockTitle: title\n    richEditorContent\n    hasCtaButton\n    ctaUrl\n    ctaText\n  }\n  ... on ExperienceDetailsDashboardBlock {\n    description\n    showMembers\n    showDates\n    showCountdown\n    showProgress\n    showAttendance\n  }\n  ... on ContentDashboardBlock {\n    contentMode: mode\n    contentUsages {\n      edges {\n        node {\n          id\n          contentId\n        }\n      }\n    }\n  }\n  ... on CollectionFolderDashboardBlock {\n    contentId\n  }\n  ... on FeaturedItemsDashboardBlock {\n    showCountdown\n    featuredKind\n    featuredProducts {\n      edges {\n        node {\n          id\n        }\n      }\n    }\n  }\n  ... on HeroDashboardBlock {\n    heroMode: mode\n    color\n    header\n    headerWithMacrosReplaced\n    subText\n    cover\n    askAi\n    showWelcomeText\n    textColor\n  }\n  ... on LeaderboardDashboardBlock {\n    leaderboardCount: count\n    leaderboardTitle: title\n    leaderboardDescription: description\n    leaderboardLookbackWindow: lookbackWindow\n    leaderboardView: view\n  }\n  ... on MembersListDashboardBlock {\n    membersListCount: count\n    memberType\n  }\n  ... on UpcomingEventsDashboardBlock {\n    count\n    eventType\n    showCover\n    eventsView: view\n  }\n  ... on FeedDashboardBlock {\n    feedTitle: title\n    feedView: view\n    feedShowCover: showCover\n  }\n  ... on CurriculumDashboardBlock {\n    curriculumTitle: title\n    curriculumView: view\n  }\n  ... on ChannelsDashboardBlock {\n    channelsTitle: title\n  }\n  ... on BannerDashboardBlock {\n    showCover\n    showDates\n    showCountdown\n    showAvailability\n    cover\n  }\n  ... on CommunityWelcomeHeroDashboardBlock {\n    title\n    subtitle\n    cover\n  }\n  ... on ContinueYourProductsDashboardBlock {\n    title\n  }\n}\n\nfragment EditorMentionsProviderFragment on Content {\n  id\n  mentions {\n    edges {\n      node {\n        id\n        user {\n          id\n          fullName\n        }\n        memberGroup {\n          id\n          name\n          kind\n          role\n        }\n        mentionedProduct {\n          id\n          name\n        }\n        mentionedContentUsage {\n          id\n          content {\n            id\n            name\n          }\n        }\n        mentionedOccurrence {\n          id\n          name\n          content {\n            name\n            id\n          }\n        }\n      }\n    }\n  }\n}\n\nfragment EventsDashboardBlockCardViewFragment on UpcomingEventsDashboardBlock {\n  position\n  productId\n  organizationId\n  showCover\n  ...DashboardBlockAdminDropdownFragment\n  ...DashboardBlockItemTemplateFragment\n}\n\nfragment EventsDashboardBlockFragment on UpcomingEventsDashboardBlock {\n  eventsView: view\n  ...EventsDashboardBlockCardViewFragment\n  ...EventsDashboardBlockListViewFragment\n}\n\nfragment EventsDashboardBlockListViewFragment on UpcomingEventsDashboardBlock {\n  productId\n  organizationId\n  count\n  position\n  view\n  ...DashboardBlockAdminDropdownFragment\n  ...DashboardBlockItemTemplateFragment\n}\n\nfragment ExperienceDetailsDashboardBlockFragment on ExperienceDetailsDashboardBlock {\n  id\n  description\n  showMembers\n  showDates\n  showCountdown\n  showProgress\n  showAttendance\n  ...DashboardBlockAdminDropdownFragment\n  ...DashboardBlockItemTemplateFragment\n}\n\nfragment ExperienceInfoToolbarFragment on BannerDashboardBlock {\n  id\n  showDates\n  showCountdown\n  showCover\n  showAvailability\n  cover\n  product {\n    ...ProductTypeTagFragment\n    id\n  }\n  ...DashboardBlockAdminDropdownFragment\n}\n\nfragment FeaturedItemsDashboardBlockFragment on FeaturedItemsDashboardBlock {\n  id\n  position\n  dashboardId\n  showCountdown\n  featuredKind\n  dashboard {\n    layout\n    id\n  }\n  ...DashboardBlockAdminDropdownFragment\n  ...DashboardBlockItemTemplateFragment\n}\n\nfragment FeedAppSettingsButtonFragment on ProductApp {\n  id\n  ...FeedAppSetupModalFragment\n}\n\nfragment FeedAppSetupModalFragment on ProductApp {\n  id\n}\n\nfragment FeedDashboardBlockCardViewFragment on FeedDashboardBlock {\n  title\n  filter\n  id\n  position\n  dashboardId\n  dashboard {\n    ...usePermissionsFragment\n    app {\n      id\n      feed {\n        id\n        ...usePermissionsFragment\n      }\n    }\n    id\n  }\n  organization {\n    id\n    viewerCanPostInFeeds\n  }\n  product {\n    id\n    viewerCanPostInFeeds\n  }\n  ...DashboardBlockAdminDropdownFragment\n  ...DashboardBlockItemTemplateFragment\n  ...PostCardFeedDashboardBlockFragment\n}\n\nfragment FeedDashboardBlockFragment on FeedDashboardBlock {\n  position\n  feedView: view\n  ...FeedDashboardBlockCardViewFragment\n  ...FeedDashboardBlockListViewFragment\n}\n\nfragment FeedDashboardBlockListViewFragment on FeedDashboardBlock {\n  id\n  title\n  filter\n  showCover\n  ...DashboardBlockAdminDropdownFragment\n  ...DashboardBlockItemTemplateFragment\n  product {\n    viewerCanPostInFeeds\n    id\n  }\n  dashboard {\n    id\n    ...usePermissionsFragment\n    app {\n      id\n      feed {\n        id\n        isInactive\n        ...AIFeedEmptyStateFragment\n        ...usePermissionsFragment\n      }\n    }\n  }\n  organization {\n    viewerCanPostInFeeds\n    id\n  }\n  ...PostCardFeedDashboardBlockFragment\n}\n\nfragment HeroDashboardBlockFragment on HeroDashboardBlock {\n  id\n  showWelcomeText\n  askAi\n  headerWithMacrosReplaced\n  subText\n  color\n  heroMode: mode\n  cover\n  textColor\n  ...DashboardBlockAdminDropdownFragment\n  ...DashboardBlockItemTemplateFragment\n}\n\nfragment LeaderboardDashboardBlockFragment on LeaderboardDashboardBlock {\n  id\n  organizationId\n  product {\n    id\n    slug\n  }\n  memberCount: count\n  title\n  blockDescription: description\n  position\n  lookbackWindow\n  blockView: view\n  ...DashboardBlockAdminDropdownFragment\n  ...DashboardBlockItemTemplateFragment\n}\n\nfragment MembersDashboardBlockFragment on MembersListDashboardBlock {\n  id\n  position\n  organizationId\n  product {\n    id\n    slug\n  }\n  memberType\n  memberCount: count\n  ...DashboardBlockAdminDropdownFragment\n  ...DashboardBlockItemTemplateFragment\n}\n\nfragment PathwaySequenceDashboardBlockFragment on PathwaySequenceDashboardBlock {\n  id\n  productId\n  ...DashboardBlockItemTemplateFragment\n}\n\nfragment PostCardFeedDashboardBlockFragment on FeedDashboardBlock {\n  showCover\n  dashboard {\n    id\n    ...usePermissionsFragment\n  }\n}\n\nfragment ProductAdminDashboardBlockFragment on ProductAdminDashboardBlock {\n  id\n  productId\n  ...DashboardBlockAdminDropdownFragment\n  ...DashboardBlockItemTemplateFragment\n  ...ProductAdminInfoToolbarFragment\n}\n\nfragment ProductAdminInfoToolbarFragment on ProductAdminDashboardBlock {\n  id\n  showDates\n  showCountdown\n  showAvailability\n  product {\n    type\n    childProducts {\n      totalCount\n    }\n    ...ProductTypeTagFragment\n    id\n  }\n}\n\nfragment ProductTypeTagFragment on Product {\n  typeTag {\n    label\n    color\n    id\n  }\n}\n\nfragment ProfileAvatarFragment on User {\n  id\n  fullName\n  avatar\n  isTest\n}\n\nfragment ProfileAvatarWithDetailsFragment on User {\n  id\n  fullName\n  ...ProfileAvatarFragment\n}\n\nfragment RecentlyViewedDashboardBlockFragment on RecentlyViewedDashboardBlock {\n  id\n  position\n  ...DashboardBlockItemTemplateFragment\n  ...DashboardBlockAdminDropdownFragment\n}\n\nfragment RichTextDashboardBlockFragment on RichTextDashboardBlock {\n  position\n  richTextBlockTitle: title\n  richEditorContent\n  hasCtaButton\n  ctaUrl\n  ctaText\n  ...DashboardBlockAdminDropdownFragment\n  ...DashboardBlockItemTemplateFragment\n}\n\nfragment UpdateContentModuleButtonFragment on ContentUsage {\n  id\n  entity\n  entityId\n  content {\n    type\n    label\n    id\n  }\n}\n\nfragment WelcomeBannerDashboardBlockFragment on WelcomeBannerDashboardBlock {\n  title\n  subtitle\n  richEditorDescription\n  cover\n  organization {\n    cover\n    id\n  }\n  ...DashboardBlockAdminDropdownFragment\n  ...DashboardBlockItemTemplateFragment\n}\n\nfragment usePermissionsFragment on Node {\n  __isNode: __typename\n  __typename\n  ... on Organization {\n    viewerPermissions\n  }\n  ... on Product {\n    nonNullProductId: id\n    viewerPermissions\n    memberPermissions\n  }\n  ... on Event {\n    nonNullProductId: productId\n    viewerPermissions\n    memberPermissions\n  }\n  ... on Comment {\n    nullableProductId: productId\n    viewerPermissions\n    memberPermissions\n  }\n  ... on Feed {\n    nullableProductId: productId\n    viewerPermissions\n    memberPermissions\n  }\n  ... on Post {\n    nullableProductId: productId\n    viewerPermissions\n    memberPermissions\n  }\n  ... on ContentUsage {\n    nullableProductIdString: productId\n    viewerPermissions\n    memberPermissions\n  }\n  ... on ChatChannel {\n    nullableProductId: productId\n    viewerPermissions\n    memberPermissions\n  }\n  ... on Dashboard {\n    nullableProductId: productId\n    viewerPermissions\n    memberPermissions\n  }\n  ... on AssignmentSubmission {\n    nonNullProductId: productId\n    viewerPermissions\n    memberPermissions\n  }\n  ... on PathwayGroup {\n    viewerPermissions\n  }\n  ... on BrainSearch {\n    viewerPermissions\n  }\n}\n"
  }
};
})();

(node as any).hash = "9810309e9fa52177d902f391a7b8e741";

export default node;
